import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import LoginPage from "layouts/Pages/Pages.jsx";
import axios from "axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { faCheckSquare, faCoffee } from "@fortawesome/free-solid-svg-icons";
 
library.add(fab, faCheckSquare, faCoffee, fas, far);

const DEBUG_MODE = window.location.host.includes("localhost");
const API = DEBUG_MODE
  ? "https://ndnt.es/api/rest/"
  : "https://" + window.location.host + "/api/rest/";

const hist = createBrowserHistory();
const smallDeviceThreshold = 765;

class App extends Component {
  constructor(props) {
    super(props);

    // console.log("mi.nadunet v1.1.0");

    this.state = {
      auxArrayCDR: []
    };
    axios.interceptors.request.use(request => {
      //// console.log("Starting Request...", request);
      return request;
    });
  }

  componentDidMount() {
    try {
      // window.addEventListener("beforeunload", ev => {
      //   ev.preventDefault();
      //   this.clearCookies();
      // });
      this.updateWindowDimensions();
      window.addEventListener("resize", this.updateWindowDimensions);
      // hist.listen(location => ReactGA.pageview(location.pathname));
    } catch (error) {
      // // console.log();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", ev => {
      ev.preventDefault();
      this.clearCookies();
    });
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    try {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
        smallDevice: window.innerWidth < smallDeviceThreshold
      });
    } catch (error) {
      // // console.log();
    }
  }

  onToggleList = () => {
    this.setState(prevState => ({ toggle: !prevState.toggle }));
  };

  render() {
    return (
      <div>
        <Router history={hist}>
          <Switch>
            <Route
              path="/"
              render={props => <LoginPage {...props} {...this} />}
            />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx